<script setup lang="ts">
import EventOptionsForm from "@/components/events/AddEditDialog/EventOptionsForm.vue";
import { VForm } from "vuetify/components/VForm";

const optionsConfig = defineModel<any[]>({ required: true });

const formRef = ref<InstanceType<typeof VForm>>();

const createDefaultOption = () => ({
  name: "",
  prompt: "",
  selections: "",
  type: "Text",
});

const handleRemove = (index: number) => {
  optionsConfig.value = optionsConfig.value?.filter((_: any, i: number) => i !== index);
};

const handleAdd = async () => {
  const result = await formRef.value?.validate();
  if (!result?.valid) return;
  optionsConfig.value = [...(optionsConfig.value ?? []), createDefaultOption()];
};

defineExpose({
  validate: () => formRef.value?.validate(),
});
</script>

<template>
  <VForm ref="formRef">
    <VWindowItem>
      <div class="mb-6">Event Options</div>
      <div>
        <EventOptionsForm
          v-for="(_, index) in optionsConfig"
          :key="index"
          v-model="optionsConfig[index]"
          @remove="handleRemove(index)"
        />
      </div>
      <div class="mt-3">
        <VBtn color="primary" @click="handleAdd">Add</VBtn>
      </div>
    </VWindowItem>
  </VForm>
</template>
